import { Box, Container, Grid, Typography, Card, CardMedia, CardContent, Chip } from '@mui/material';
import { Calendar, Clock, MapPin } from 'lucide-react';

export function LatestEvents({ data }) {
  const primaryColor = data.primary_color || '#1e3a8a';
  const events = Array.isArray(data.events) ? data.events : [];

  if (events.length === 0) return null;

  return (
    <Box id="events" sx={{ py: { xs: 8, md: 12 }, backgroundColor: '#f8fafc' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', maxWidth: 640, mx: 'auto', mb: 6 }}>
          <Box sx={{ display: 'inline-block', px: 2, py: 0.5, borderRadius: 4, backgroundColor: `${primaryColor}15`, color: primaryColor, mb: 1.5 }}>
            <Typography variant="caption" fontWeight={700} letterSpacing="0.05em">
              WHAT'S HAPPENING
            </Typography>
          </Box>
          <Typography variant="h2" fontWeight={800} color="#0f172a" sx={{ fontSize: { xs: '2rem', md: '2.5rem' }, mb: 1 }}>
            Upcoming Events & Activities
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Stay updated with our latest workshops, sports meets, and cultural programs.
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {events.map((ev, index) => (
            <Grid size={{ xs: 12, md: 4 }} key={ev.id || index}>
              <Card
                elevation={0}
                sx={{
                  borderRadius: 4,
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  backgroundColor: '#ffffff',
                  border: '1px solid #e2e8f0',
                  boxShadow: '0 10px 25px rgba(0,0,0,0.05)',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-6px)',
                    boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                  },
                }}
              >
                {ev.image && (
                  <CardMedia component="img" image={ev.image} alt={ev.title} sx={{ height: 200, objectFit: 'cover' }} />
                )}
                <CardContent sx={{ p: 3, flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                  <Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5, flexWrap: 'wrap' }}>
                      {ev.date && (
                        <Chip
                          icon={<Calendar size={14} color={primaryColor} />}
                          label={ev.date}
                          size="small"
                          sx={{ backgroundColor: `${primaryColor}10`, color: primaryColor, fontWeight: 700 }}
                        />
                      )}
                      {ev.time && (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: 'text.secondary', fontSize: '0.8rem' }}>
                          <Clock size={14} />
                          <span>{ev.time}</span>
                        </Box>
                      )}
                    </Box>

                    <Typography variant="h6" fontWeight={800} color="#0f172a" sx={{ mb: 1, lineHeight: 1.3 }}>
                      {ev.title}
                    </Typography>

                    {ev.description && (
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 2, lineHeight: 1.6 }}>
                        {ev.description}
                      </Typography>
                    )}
                  </Box>

                  {ev.location && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, pt: 2, borderTop: '1px solid #f1f5f9', color: 'text.secondary', fontSize: '0.85rem', fontWeight: 600 }}>
                      <MapPin size={16} color={primaryColor} />
                      <span>{ev.location}</span>
                    </Box>
                  )}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default LatestEvents;
